<template lang="html">

    <div data="datos-personales" class="cv-part">
        <h2 class="title" @click="openedit">Datos personales</h2>
        <p v-if="!!personales.DNI">NIF/NIE/Pasaporte: <span>{{personales.DNI}}</span></p>
        <p v-if="!!personales.nacionalidad">Nacionalidad: <span>{{personales.nacionalidad}}</span></p>
        <p>Permiso de trabajo: <span>{{(tienePermisoTrabajo) ? 'Sí':'No'}}</span></p>
        <p v-if="!!personales.fecha_nacimiento">Fecha de nacimiento: <span>{{personales.fecha_nacimiento}}</span></p>
        <p>Discapacidad certificada: <span>{{(discapacidad.discapacidad) ? 'Sí':'No'}}</span></p>
        <p>Trabajando actualmente: <span>{{(trabajando) ? 'Sí':'No'}}</span></p>

        <div class="cover-popup row-center" v-if="showedit">
          <div class="popup">
    
            <a class="close" @click="showedit = false">✕</a>
            <h2 class="title-pop">Editar datos personales</h2>
    
            <div class="toggle-checkbox" :edit="showedit">
              <input type="checkbox" id="permisodetrabajo" @change="editPermisoTrabajo(tienePermisoTrabajoedit)" v-model="tienePermisoTrabajoedit">
              <label for="permisodetrabajo">Permiso de trabajo</label>
            </div>

            <div class="toggle-checkbox" :edit="showedit">
              <input type="checkbox" id="trabajandoactualmente" v-model="trabajandoedit" @change="editTrabajandoActualmente(trabajandoedit)">
              <label for="trabajandoactualmente">Trabajando actualmente</label>
            </div>

            <div class="toggle-checkbox" :edit="showedit">
              <input type="checkbox" id="discapacidad" v-model="valuediscapacidad.discapacidad" @change="editDiscapacidad(valuediscapacidad.discapacidad)">
              <label for="discapacidad">Discapacidad certificada</label>
            </div>

            <template v-if="canEditPersonales">

              <div class="input-text">
                <label for="dni">NIF/NIE/Pasaporte</label>
                <input type="text" id="dni" v-model="dni" name="dni"
                  v-validate="'required'">
                <span class="error animated shake"
                  v-if="errors.has('perfil_digital')">{{ errors.first('dni') }}</span>
              </div>

              <div class="datepicker-container" :error="errors.has('fechadenacimiento')">
                <label for="">Fecha de nacimiento</label>
                <datepicker :placeholder="'Fecha de nacimiento'" :language="es" :full-month-name="true" :monday-first="true"
                  :format="'dd MMMM yyyy'" :minimum-view="'day'" v-model="fechadenacimiento" v-validate="'required'"
                  :required="true" name="fechadenacimiento"></datepicker>
                <span class="error animated shake" v-if="errors.has('fechadenacimiento')">{{ errors.first('fechadenacimiento') }}</span>
              </div>

            </template>
      
    
            <button class="btn" @click="saveData" :loading="loading" v-if="canEditPersonales">Guardar</button>
          </div>
        </div>

      </div>

</template>

<script lang="js">

  import {mapActions,mapGetters} from 'vuex';

  import Datepicker from 'vuejs-datepicker';

  import { es } from 'vuejs-datepicker/dist/locale';

  export default  {
    name: 'datos-personales',
    props : ['tienePermisoTrabajo','personales','discapacidad','trabajando'],
    mounted(){
      this.trabajandoedit = this.trabajando;
      this.tienePermisoTrabajoedit = this.tienePermisoTrabajo;
      this.dni = this.personales.DNI;
      this.valuediscapacidad = this.discapacidad;
      let split = this.personales.fecha_nacimiento.split("/");
      let date = new Date(split[2], Number(split[1])-1, split[0]);

      this.fechadenacimiento = date;
    },
    data() {
      return {
        showedit: false,
        trabajandoedit : false,
        tienePermisoTrabajoedit: false,
        fechadenacimiento : '',
        valuediscapacidad : '',
        es: es,
        loading: false
      }
    },
    computed:{
      ...mapGetters({
        canEditPersonales: 'canEditPersonales'
      })
    },
    methods :{
      ...mapActions(['editTrabajandoActualmente','editPermisoTrabajo','canEditCv','editPersonales','editDiscapacidad']),
      openedit(){
        this.canEditCv().then(r =>{
          (r) ? this.showedit = true : '';
        });
      },
      saveData(){

        let date = new Date(this.fechadenacimiento);

        let data = {
          fecha_nacimiento : `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`,
          DNI : this.dni
        }

        this.loading = true;

        this.editPersonales(data).then( r => {
          if(r){
            this.loading = false;
            this.showedit = false;
          }
        });

      }
    },
    components: {
      Datepicker
    }
}
</script>

<style scoped lang="scss">

  .datepicker-container{
    padding-left: 0;
    width: 100%;
    label{
      font-size: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/mi-cv/datos-personales.vue